import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Paint = createSvgIcon(
  <path d="M5.25 0H22.5v7.5H5.25v-3h-1.5v5.25h9.75v3.75h2.25V24H9V13.5h2.25V12H1.5V2.25h3.75V0ZM7.5 2.25v3h12.75v-3H7.5Zm3.75 13.5v6h2.25v-6h-2.25Z" />,
  'Paint'
);

export { Paint };